import { Box, CircularProgress, Typography } from "@mui/material";

export const CircularLoadingWithLabel = ({
  text,
  alignText = "row",
}: {
  text: string;
  alignText?: "row" | "column";
}): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: alignText,
        // justifyContent: "center",
        gap: "5px",
      }}
    >
      <Typography sx={{ alignSelf: "end" }} component="span">
        {text}
      </Typography>
      <CircularProgress />
    </Box>
  );
};
